import { render, staticRenderFns } from "./CourseDialog.vue?vue&type=template&id=706aeee6&scoped=true&"
import script from "./CourseDialog.vue?vue&type=script&lang=js&"
export * from "./CourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseDialog.vue?vue&type=style&index=0&id=706aeee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706aeee6",
  null
  
)

export default component.exports